

























































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Signup extends Vue {
	handle = "";
	status = "";
	skills = "";
	githubusername = "";
	company = "";
	website = "";
	location = "";
	bio = "";
	youtube = "";
	facebook = "";
	twitter = "";
	linkedin = "";
	instagram = "";
	loadingProfileInfo = false;

	status_fields = [
		"Developer",
		"Junior Developer",
		"Seniour Developer",
		"Software Engineer",
		"Data Scintist",
		"Manager",
		"Designer",
		"Student or Learning",
		"Instructor or Teacher",
		"Intern",
		"UI/UX Designer",
		"System Analyst"
	];

	clear() {
		this.handle = "";
		this.status = "";
		this.skills = "";
		this.githubusername = "";
		this.company = "";
		this.website = "";
		this.location = "";
		this.bio = "";
		this.youtube = "";
		this.facebook = "";
		this.twitter = "";
		this.linkedin = "";
		this.instagram = "";
		(this.$refs.singupObserver as Vue & { reset: () => boolean }).reset();
	}

	submit() {
		this.loadingProfileInfo = true;
		(this.$refs.singupObserver as Vue & {
			validate: () => any;
		})
			.validate()
			.then((isValid: boolean) => {
				if (isValid) {
					const info = {
						handle: this.handle,
						status: this.status,
						skills: this.skills,
						githubusername: this.githubusername,
						company: this.company,
						website: this.website,
						location: this.location,
						bio: this.bio,
						youtube: this.youtube,
						facebook: this.facebook,
						twitter: this.twitter,
						linkedin: this.linkedin,
						instagram: this.instagram
					};

					console.log("to be send...", info);

					this.$store
						.dispatch("profile/setProfileInfo", info)
						.then(res => {
							console.log(res, "it has been sent...");
							this.loadingProfileInfo = false;
							this.$router.push({ name: "Profile" });
						})
						.catch(err => {
							setTimeout(() => (this.loadingProfileInfo = false), 2000);
							console.log(err);
						});
				} else {
					setTimeout(() => (this.loadingProfileInfo = false), 2000);
				}
			})
			.catch((error: any) => {
				setTimeout(() => (this.loadingProfileInfo = false), 2000);
				console.log(error);
			});
	}
}
